import { FC, useState } from 'react';

import CopyIcon from 'components/icons/CopyIcon';
import UsersIcon from 'components/icons/UsersIcon';
import CommonContainer from 'components/primitives/CommonContainer';
import ToastHelper from 'utils/toast';

type ReferralCodeCardProps = {
  referralCode: string;
  totalReferredUsers?: number;
};

const ReferralCodeCard: FC<ReferralCodeCardProps> = ({
  referralCode,
  totalReferredUsers = 0,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(referralCode);
      setCopied(true);
      ToastHelper.success('Referral code copied to clipboard!');
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      ToastHelper.error('Failed to copy referral code');
    }
  };

  // Format referral code with "REF-" prefix
  const formattedCode = referralCode.startsWith('REF-')
    ? referralCode
    : `REF-${referralCode}`;

  return (
    <CommonContainer>
      <div className="w-full flex flex-col gap-6">
        <h2 className="text-neutral-700 text-2xl font-bold font-primary">
          Your Referral Code
        </h2>
        <div className="flex items-center gap-4 flex-wrap">
          <div className="bg-gray-100 rounded-lg px-4 py-3 flex items-center min-w-[120px]">
            <div className="text-neutral-700 text-lg font-semibold font-mono">
              {formattedCode}
            </div>
          </div>
          <button
            onClick={handleCopy}
            className="flex items-center justify-center cursor-pointer hover:opacity-70 transition-opacity p-1"
            aria-label="Copy referral code">
            <CopyIcon w="24" h="24" fill={copied ? '#22CC7A' : '#515151'} />
          </button>
          <span className="text-neutral-500 text-sm font-secondary flex-1">
            Share this code with friends to earn points when they sign up!
          </span>
        </div>
        <div className="flex items-center gap-4 pt-4 border-t border-gray-200">
          <div className="flex items-center gap-3">
            <UsersIcon w="24" h="24" fill="#22CC7A" />
            <span className="text-neutral-700 text-base font-semibold font-secondary">
              Total Referred Users
            </span>
          </div>
          <span className="text-neutral-700 text-2xl font-bold font-primary">
            {totalReferredUsers}
          </span>
        </div>
      </div>
    </CommonContainer>
  );
};

export default ReferralCodeCard;
